import React, {Fragment, useMemo} from 'react'

import Bg1 from '../../images/backgrounds/bg1.jpg'
import LogoFull from '../../images/logo-full.png'
import ConsultPdfCheck from '../../images/icons/consult-pdf--check.png'
import ConsultPdfRsaquo from '../../images/icons/consult-pdf--rsaquo.png'
import {GetConsultPdfResponse} from '../../redux/consult'

import './styles.css'

/**
 * This is the component that effectively builds the HTML structure that will be
 * converted to a PDF using jsPDF's html method. Each entry from the "pages"
 * array is supposed to be a page from the resulting document.
 */
const View = React.forwardRef<HTMLHtmlElement, GetConsultPdfResponse>(
  ({info, member}, ref) => {
    const pdf = useMemo(() => {
      let pages = []

      pages.push(
        <div id="page_0_0">
          <img id="page_0_0_background" src={Bg1} />
          <div className="lines upper">
            <div className="pdf-line" />
            <div className="pdf-line" />
            <div className="pdf-line" />
          </div>
          <div id="page_0_0_content">
            <img id="logo" src={LogoFull} />
            <h1 id="page_0_h1">Consultation Summary</h1>
            <h2 id="page_0_h2">Consultation Summary for {info.name}</h2>
          </div>
          <div className="lines lower">
            <div className="pdf-line" />
            <div className="pdf-line" />
            <div className="pdf-line" />
          </div>
        </div>,
      )

      // TODO: implement Table of Contents with internal links like tocentry (from PHP's mPDF)
      // pages.push(
      //   <div id="page_1_0">
      //     <h2 id="page_1_h2">Table of Contents</h2>
      //     {member.results.map((result) => (
      //       <a href={`#page_${result.catName + 3}`}>{result.catName}</a>
      //     ))}
      //     <a href="#page_third_to_last_0">Recommended Resources</a>
      //     <a href="#page_penultimate_0">Closing Comments</a>
      //   </div>
      // );

      pages.push(
        <div id="page_2_0">
          <blockquote id="page_2_bq">
            “Believe in yourself and all that you are Know that there is
            something inside you that is greater than any obstacle”
          </blockquote>
          <footer id="page_2_f">
            <cite> - Christian D Larson</cite>
          </footer>
        </div>,
      )

      pages.push(
        <div id="page_3_0_container">
          <div id="page_3_0_content_0">
            <h2 id="page_3_0_content_0_h2">Summary from Exam Results</h2>
            <h3 className="page_3_0_content_0_h3">Report Summary:</h3>
            <p className="summary">{member.outsides.summary}</p>
            <h3 className="page_3_0_content_0_h3">
              How To Apply This To Your Study Approach:
            </h3>
            <p className="summary">{member.outsides.how_apply}</p>
          </div>
          <div id="page_3_0_content_1">
            <h2 id="page_3_0_content_1_h2">Information:</h2>
            <ul className="info">
              <li>
                <span className="label">User:</span> {info.name}
              </li>
              <li>
                <span className="label">Exam:</span> {info.exam}
              </li>
              <li>
                <span className="label">Email:</span> {info.email}
              </li>
              <li>
                <span className="label">Consultant:</span> {info.consultant}
              </li>
              <li>
                <span className="label">Summary Date:</span> {info.date}
              </li>
            </ul>
          </div>
        </div>,
      )

      for (const [key, result] of Object.entries(member.results)) {
        const preface =
          key === '0' ? (
            <p className="next-few-pages">
              The next few pages will provide summary of the results from the
              pre-consultation survey and experiences discussed during the
              consultation.
            </p>
          ) : null

        // TODO: implement proper page breaks like tocpagebreak (from PHP's mPDF)
        if (result.subCats.length > 3) {
          pages.push(
            <>
              <div id="header_0" className="header">
                Survey Summary
              </div>
              {preface}
              <h2 className="cat">
                <span className="cat-no">0{result.catId}: </span>
                <span className="cat-name">{result.catName}</span>
              </h2>
              {result.subCats.slice(0, 3).map(subCat => (
                <Fragment key={subCat.subCatId}>
                  <div
                    className={`subcat ${
                      subCat.consultant ? 'reply' : 'no-reply'
                    }`}
                  >
                    <img
                      className={`consult-mark consult-mark-${
                        subCat.consultant ? 'rsaquo' : 'check'
                      }`}
                      src={
                        subCat.consultant ? ConsultPdfRsaquo : ConsultPdfCheck
                      }
                      width="0.25in"
                    />
                    <h3 className="subcat-heading">{subCat.subCatName}</h3>
                    {subCat.consultant ? (
                      <>
                        <h4 className="subclass-consultant-heading">
                          {info.consultant}:{' '}
                        </h4>
                        <p className="subcat-consultant">{subCat.consultant}</p>
                      </>
                    ) : null}
                  </div>
                </Fragment>
              ))}
            </>,
          )

          pages.push(
            <>
              <div id="header_0" className="header">
                Survey Summary
              </div>
              <h2 className="cat">
                <span className="cat-no">0{result.catId}: </span>
                <span className="cat-name"> {result.catName}</span>
              </h2>
              {result.subCats.slice(3, result.subCats.length).map(subCat => (
                <Fragment key={subCat.subCatId}>
                  <div
                    className={`subcat ${
                      subCat.consultant ? 'reply' : 'no-reply'
                    }`}
                  >
                    <img
                      className={`consult-mark consult-mark-${
                        subCat.consultant ? 'rsaquo' : 'check'
                      }`}
                      src={
                        subCat.consultant ? ConsultPdfRsaquo : ConsultPdfCheck
                      }
                      width="0.25in"
                    />
                    <h3 className="subcat-heading">{subCat.subCatName}</h3>
                    {subCat.consultant ? (
                      <>
                        <h4 className="subclass-consultant-heading">
                          {info.consultant}:{' '}
                        </h4>
                        <p className="subcat-consultant">{subCat.consultant}</p>
                      </>
                    ) : null}
                  </div>
                </Fragment>
              ))}
            </>,
          )
        } else {
          pages.push(
            <>
              <div id="header_0" className="header">
                Survey Summary
              </div>
              {preface}
              <h2 className="cat">
                <span className="cat-no">0{result.catId}: </span>
                <span className="cat-name"> {result.catName}</span>
              </h2>
              {result.subCats.map(subCat => (
                <Fragment key={subCat.subCatId}>
                  <div
                    className={`subcat ${
                      subCat.consultant ? 'reply' : 'no-reply'
                    }`}
                  >
                    <img
                      className={`consult-mark consult-mark-${
                        subCat.consultant ? 'rsaquo' : 'check'
                      }`}
                      src={
                        subCat.consultant ? ConsultPdfRsaquo : ConsultPdfCheck
                      }
                      width="0.25in"
                    />
                    <h3 className="subcat-heading">{subCat.subCatName}</h3>
                    {subCat.consultant ? (
                      <>
                        <h4 className="subclass-consultant-heading">
                          {info.consultant}:{' '}
                        </h4>
                        <p className="subcat-consultant">{subCat.consultant}</p>
                      </>
                    ) : null}
                  </div>
                </Fragment>
              ))}
            </>,
          )
        }
      }

      pages.push(
        <div id="page_third_to_last_0">
          <h2 id="page_recommended_0_h2">Recommended Resources</h2>
          <div id="page_recommended">
            <div id="page_recommended_left">
              <h2 id="page_recommended_1_h2">Recommended Books</h2>
              <p className="recommended-resources">
                {member.outsides.recommended_books
                  .split('\n')
                  .map((recommendedBook, index) => (
                    <Fragment key={`recommended_book_${index}`}>
                      {recommendedBook}
                      <br />
                      <br />
                    </Fragment>
                  ))}
              </p>
            </div>
            <div id="page_recommended_right">
              <h2 id="page_recommended_1_h2">Recommended Links</h2>
              <p
                className="recommended-resources"
                dangerouslySetInnerHTML={{
                  __html: member.outsides.recommended_links
                    .replace(
                      /https:\/\/(.*)\s/g,
                      `<a href="https://$1">https://$1</a><br />\n`,
                    )
                    .replace(/\n/g, '<br />'),
                }}
              />
            </div>
          </div>
        </div>,
      )

      pages.push(
        <div id="page_penultimate_0">
          <div id="page_closing_0_container">
            <div id="page_closing_0">
              <h2 id="page_closing_0_h2">Closing Comments</h2>
              <p className="closing-comments-preface">
                Thanks again for taking the time to speak with us. Doing so says
                a lot about you and your commitment to becoming licensed and we
                applaud you for that. We hope this was beneficial for you and
                has given you some ideas and adjustments for your next exam.
                Don’t forget to let us know when you’ve pass all your exams and
                are licensed so we can send you a cool little gift!
              </p>
              <p className="closing-comments">
                {member.outsides.closing_comments}
              </p>
              <p className="copyright">
                © Black Spectacles {new Date().getFullYear()} All Rights
                Reserved For your eyes only
              </p>
            </div>
          </div>
        </div>,
      )

      pages.push(
        <div id="page_last_0">
          <div className="lines upper">
            <div className="pdf-line" />
            <div className="pdf-line" />
            <div className="pdf-line" />
          </div>
          <div id="page_last_0_content">
            <img id="logo" src={LogoFull} />
            <p id="page_last_0_email">
              <a href="mailto:hello@blackspectacles.com">
                hello@blackspectacles.com
              </a>
            </p>
            <p id="page_last_0_addr">
              2093 Philadelphia Pike #8864
              <br />
              Claymont, DE 19703
            </p>
          </div>
          <div className="lines lower">
            <div className="pdf-line" />
            <div className="pdf-line" />
            <div className="pdf-line" />
          </div>
        </div>,
      )

      pages = pages.map((page, index) =>
        // TODO: change "index < 3" back to "index < 4" once Table of Contents is implemented
        index < 3 || index > pages.length - 4 ? (
          page
        ) : (
          // TODO: change "index + 1" back to "index" once Table of Contents is implemented
          <div key={`page_${index + 1}_0`} id={`page_${index + 1}_0`}>
            {/* TODO: change "index > 2" back to "index > 3" once Table of Contents is implemented */}
            {index > 2 && index < pages.length - 1 && (
              <h2 className="page_no">{index + 1}</h2>
            )}
            {page}
          </div>
        ),
      )

      // TODO: find a way to remove the mysterious blank page appended to the end of the PDF

      return pages
    }, [info, member])

    return (
      <html id="pdf" ref={ref}>
        <body>{pdf}</body>
      </html>
    )
  },
)

View.displayName = 'ConsultPdf'

export default View
